export  const FeedbackConstant = {
    FEEDBACK_SAGA: "FEEDBACK_SAGA",
    FEEDBACK_REQUEST: "FEEDBACK_REQUEST",
    FEEDBACK_RESPONSE: "FEEDBACK_RESPONSE",
    FEEDBACK_API: "/get-feedback",


    FEEDBACK_REPLY_API: "/feedback/reply",
  };
  